import { useI18n } from '../../shared/i18n';
import { useState } from 'react';
import { Modal } from '../../shared/ui';

export function StockPhoto({ base, code }: { base?: string | null; code?: string }) {
  const { t } = useI18n();
  const [expanded, setExpanded] = useState(false);
  const [failed, setFailed] = useState('');
  const url = base && code ? base + encodeURIComponent(code) + '.jpg' : '';
  const image = url && failed !== url ? <img src={url} alt={t('Artikel {code}', { code: code ?? '' })} onError={() => setFailed(url)} referrerPolicy="no-referrer" /> : <span>{t("Kein Photo verfügbar")}</span>;
  return <><button type="button" className="stock-photo" onClick={() => setExpanded(true)} disabled={!url || failed === url} aria-label={t("Photo vergrößern")}>{image}</button>
    {expanded && <Modal title={t('Photo – {code}', { code: code ?? '' })} onClose={() => setExpanded(false)}><div className="stock-photo-large">{image}</div></Modal>}</>;
}
